import React from "react";
import DynamicTable from "../../../Components/InputComponents/LookupView";
import { Edit, Delete, Visibility, FileCopy } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { encryptId } from "../../../Components/CryptoComponent";

function RecruitmentProcedureList() {
  const navigate = useNavigate();
  const columns = [
    { field: "RP_Id", label: "#" },
    { field: "RP_Name", label: "Recruitment Procedure" },
  ];

  const [searchParams] = useSearchParams();

  const actions = [
    {
      icon: Visibility,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.RP_Id));
        navigate(`/RecruitmentProcedure/View/${encrypted}?${searchParams.toString()}`);
      },
      color: "primary",
    },
    {
      icon: FileCopy,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.RP_Id));
        navigate(`/RecruitmentProcedure/Clone/${encrypted}?${searchParams.toString()}`);
      },
      color: "warning",
      tooltip: "Clone this Recruitment Procedure",
    },
  ];

  return (
    <DynamicTable
      columns={columns}
      // data={data}
      dataAPI={`/RecruitmentProcedure/list`}
      actions={actions}
      title={`Recruitment Procedure`}
      linkvalue={`/RecruitmentProcedure/Add?${searchParams.toString()}`}
    />
  );
}

export default RecruitmentProcedureList;
